import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-be412a88"),n=n(),_popScopeId(),n)
const _hoisted_1 = { ref: "dialog" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dialog-title" }, "対局", -1))
const _hoisted_3 = { class: "dialog-form-area" }
const _hoisted_4 = { class: "players" }
const _hoisted_5 = { class: "player" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "top-label" }, "先手（下手）", -1))
const _hoisted_7 = ["value"]
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "player" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "top-label" }, "後手（上手）", -1))
const _hoisted_11 = ["value"]
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "players-control" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" 先後入れ替え ")
const _hoisted_15 = { class: "dialog-form-areas-h" }
const _hoisted_16 = { class: "dialog-form-area time-limit" }
const _hoisted_17 = { class: "dialog-form-item" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dialog-form-item-label" }, "持ち時間", -1))
const _hoisted_19 = ["value"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dialog-form-item-unit" }, "時間", -1))
const _hoisted_21 = ["value"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dialog-form-item-unit" }, "分", -1))
const _hoisted_23 = { class: "dialog-form-item" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dialog-form-item-label" }, "秒読み", -1))
const _hoisted_25 = ["value"]
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dialog-form-item-unit" }, "秒", -1))
const _hoisted_27 = { class: "dialog-form-item" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dialog-form-item-label" }, "増加", -1))
const _hoisted_29 = ["value"]
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dialog-form-item-unit" }, "秒", -1))
const _hoisted_31 = { class: "dialog-form-area flags" }
const _hoisted_32 = { class: "dialog-form-item" }
const _hoisted_33 = ["value"]
const _hoisted_34 = /*#__PURE__*/_createStaticVNode("<option value=\"current\" data-v-be412a88>現在の局面</option><option value=\"standard\" data-v-be412a88>平手</option><option value=\"handicapLance\" data-v-be412a88>香落ち</option><option value=\"handicapRightLance\" data-v-be412a88>右香落ち</option><option value=\"handicapBishop\" data-v-be412a88>角落ち</option><option value=\"handicapRook\" data-v-be412a88>飛車落ち</option><option value=\"handicapRookLance\" data-v-be412a88>飛車香落ち</option><option value=\"handicap2Pieces\" data-v-be412a88>2枚落ち</option><option value=\"handicap4Pieces\" data-v-be412a88>4枚落ち</option><option value=\"handicap6Pieces\" data-v-be412a88>6枚落ち</option><option value=\"handicap8Pieces\" data-v-be412a88>8枚落ち</option>", 11)
const _hoisted_45 = [
  _hoisted_34
]
const _hoisted_46 = { class: "dialog-form-item" }
const _hoisted_47 = ["checked"]
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "disable-engine-timeout" }, "エンジンの時間切れあり", -1))
const _hoisted_49 = { class: "dialog-form-item" }
const _hoisted_50 = ["checked"]
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "human-is-front" }, "人を手前に表示する", -1))
const _hoisted_52 = { class: "dialog-main-buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonIcon = _resolveComponent("ButtonIcon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("dialog", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("select", {
              ref: "blackPlayerSelect",
              class: "player-select",
              size: "1",
              value: _ctx.defaultValues.black.type
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.players, (player) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: player.uri,
                  value: player.uri
                }, _toDisplayString(player.name), 9, _hoisted_8))
              }), 128))
            ], 8, _hoisted_7)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("select", {
              ref: "whitePlayerSelect",
              class: "player-select",
              size: "1",
              value: _ctx.defaultValues.white.type
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.players, (player) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: player.uri,
                  value: player.uri
                }, _toDisplayString(player.name), 9, _hoisted_12))
              }), 128))
            ], 8, _hoisted_11)
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onSwapColor && _ctx.onSwapColor(...args)))
          }, [
            _createVNode(_component_ButtonIcon, {
              class: "icon",
              icon: "swap_h"
            }),
            _hoisted_14
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _createElementVNode("input", {
              ref: "hours",
              class: "time-input",
              type: "number",
              min: "0",
              max: "99",
              step: "1",
              value: _ctx.defaultValues.timeLimit.hours
            }, null, 8, _hoisted_19),
            _hoisted_20,
            _createElementVNode("input", {
              ref: "minutes",
              class: "time-input",
              type: "number",
              min: "0",
              max: "59",
              step: "1",
              value: _ctx.defaultValues.timeLimit.minutes
            }, null, 8, _hoisted_21),
            _hoisted_22
          ]),
          _createElementVNode("div", _hoisted_23, [
            _hoisted_24,
            _createElementVNode("input", {
              ref: "byoyomi",
              class: "time-input single",
              type: "number",
              min: "0",
              max: "60",
              step: "1",
              value: _ctx.defaultValues.timeLimit.byoyomi
            }, null, 8, _hoisted_25),
            _hoisted_26
          ]),
          _createElementVNode("div", _hoisted_27, [
            _hoisted_28,
            _createElementVNode("input", {
              ref: "increment",
              class: "time-input single",
              type: "number",
              min: "0",
              max: "99",
              step: "1",
              value: _ctx.defaultValues.timeLimit.increment
            }, null, 8, _hoisted_29),
            _hoisted_30
          ])
        ]),
        _createElementVNode("div", _hoisted_31, [
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("select", {
              ref: "startPosition",
              value: _ctx.defaultValues.startPosition
            }, _hoisted_45, 8, _hoisted_33)
          ]),
          _createElementVNode("div", _hoisted_46, [
            _createElementVNode("input", {
              id: "disable-engine-timeout",
              ref: "enableEngineTimeout",
              type: "checkbox",
              checked: _ctx.defaultValues.enableEngineTimeout
            }, null, 8, _hoisted_47),
            _hoisted_48
          ]),
          _createElementVNode("div", _hoisted_49, [
            _createElementVNode("input", {
              id: "human-is-front",
              ref: "humanIsFront",
              type: "checkbox",
              checked: _ctx.defaultValues.humanIsFront
            }, null, 8, _hoisted_50),
            _hoisted_51
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_52, [
        _createElementVNode("button", {
          class: "dialog-button",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onStart()))
        }, "対局開始"),
        _createElementVNode("button", {
          class: "dialog-button",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onCancel()))
        }, "キャンセル")
      ])
    ], 512)
  ]))
}